<div *ngIf="loading$ | async" class="overlay"> 
    <div class="loader">
        <div class="spinner"></div>
    </div> 
</div>